import { render } from "./MainContainer.vue?vue&type=template&id=786fd089"
import script from "./MainContainer.vue?vue&type=script&lang=js"
export * from "./MainContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__